import styled from "styled-components";
import { theme } from "@themes";

export const CancelConfirmationContent = styled.div`
  background: white;
  width: 26em;
  display: block;
  padding: 1em;
  border-radius: 7px;
  margin: 20em auto;

  .text {
    font-size: 15px;
    text-align: center;
    padding: 10px;
  }

  .system-alert {
    text-align: center;
    font-size: 24px;
    font-weight: 600;
  }

  .popUpActionButton {
    position: relative;
    bottom: 0px;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    button {
      margin: 15px;
      width: 112px;
      height: 40px;
      outline: none;
      border: none;
      background-color: ${({ theme }) => theme.button.primary};
      color: ${({ theme }) => theme.neutral.white};
      border-radius: 5px;
    }
    .cancel {
      background-color: ${({ theme }) => theme.neutral.white};
      color: ${({ theme }) => theme.neutral.black};
      border: 1px solid ${({ theme }) => theme.button.primaryBorder};
    }
  }
`;
